module.exports = __webpack_public_path__ + "static/media/bg_fruit_persimmon.5a67414a.png";